import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { State } from '@app/store/state/state';
import { widgetsRootSelector } from '@shared/widgets/store/selectors/widgets-root.selector';
import { AlertResponse, AlertPayload, AlertIdentificators } from '@shared/widgets/entities/alerts';
import { WidgetsState } from '@shared/widgets/store/state/widgets.state';
import {
  loadAlertAction,
  createAlertAction,
  setActiveAlertsUIAction,
  deleteAlertAction,
  closeDeleteToastAction
} from '@shared/widgets/store/actions/alerts.action';
import { selectUserAlertsEntities } from '@app/store/selectors/user-alerts.selector';

@Injectable()
export class WidgetsFacade {

  constructor(
    private store: Store<State>
  ) { }

  public alert$: Observable<AlertResponse> = this.store
    .pipe(
      select(widgetsRootSelector),
      map((state: WidgetsState) => state.alert)
    );

  get alertsEntities$(): Observable<AlertResponse[]> {
    return this.store.pipe(
      select(selectUserAlertsEntities)
    );
  }

  public activeAlerts$: Observable<boolean> = this.store
    .pipe(
      select(widgetsRootSelector),
      map((state: WidgetsState) => state.ui.activateAlerts)
    );

  public showAlertToast$: Observable<string> = this.store
    .pipe(
      select(widgetsRootSelector),
      map((state: WidgetsState) => state.ui.showAlertToast)
    );

  public saveThisSearch$: Observable<boolean> = this.store
    .pipe(
      select(widgetsRootSelector),
      map((state: WidgetsState) => state.ui.saveThisSearch)
    );

  public createAlert$: Observable<boolean> = this.store
    .pipe(
      select(widgetsRootSelector),
      map((state: WidgetsState) => state.ui.createAlert)
    );

  public loadAlertData(): void {
    this.store.dispatch(loadAlertAction());
  }

  public createAlert(payload: AlertPayload): void {
    this.store.dispatch(createAlertAction({ payload }));
  }

  public deleteAlert(alert: AlertIdentificators): void {
    this.store.dispatch(deleteAlertAction({ alert }));
  }

  public setActiveAlertsUI(payload: boolean): void {
    this.store.dispatch(setActiveAlertsUIAction({ payload }));
  }

  public closeDeleteToast(): void {
    this.store.dispatch(closeDeleteToastAction());
  }

}
